import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { HideShellOnScrollDirective } from '../../../directives/hide-shell-on-scroll.directive';

@Component({
  selector: 'app-resume-shell',
  standalone: true,
  imports: [
    CommonModule,
    HideShellOnScrollDirective // 👈 DAS ist der Fix
  ],
  templateUrl: './resume-shell.component.html',
  styleUrl: './resume-shell.component.css',
  encapsulation: ViewEncapsulation.None // wird benoetigt fuer dark container

})
export class ResumeShellComponent {
  @Input() tabs: { label: string; icon: string }[] = [];
  @Input() activeIndex = 0;

  @Input() tabContent: {
    experience: unknown[];
    skills: { ICON: string }[];
    education: unknown[];
  } = {
    experience: [],
    skills: [],
    education: []
  };

  @Input() scrollPrefix = 'resume';

  @Output() tabChange = new EventEmitter<number>();

  onTabClick(index: number): void {
    this.tabChange.emit(index);
  }
}
